import type { InvoiceListApiData } from '@navio/nsdk';
import { filterUnitFor } from 'noddi-ui-web';

export type InvoiceListFilterInput = Omit<
  NonNullable<InvoiceListApiData['query']>,
  'pageIndex' | 'pageSize' | 'ordering' | 'search'
>;

/** Invoice list unit factory: hosts build their scope and filters with it for `InvoicesListPage`. */
export const invoiceFilterUnit = filterUnitFor<InvoiceListFilterInput>();
